/* Single source of truth for "are we in a dev/preview context".
 * Gates the diagnostic ContentNotFoundBanner (and the dev-vs-prod choice in
 * ContentFallback) so internal tree names never leak to shoppers in production. */
export const isPreviewOrDev = () => {
    if (process.env.NODE_ENV !== 'production') return true
    if (typeof window !== 'undefined' && window.location) {
        const params = new URLSearchParams(window.location.search)
        if (params.get('epieditmode') === 'true' || params.get('preview_token')) return true
    }
    return false
}
